// extracted by mini-css-extract-plugin
export default {"agentMap":"agentMap_57SwZ","title":"title_ulf79"};